import { createAction } from 'redux-starter-kit';

export const putDamageTypes = createAction('PUT_DAMAGE_TYPES');
export const putDamageType = createAction('PUT_DAMAGE_TYPE');
export const putDamageTypeReferences = createAction('PUT_DAMAGE_TYPE_REFERENCES');
